/**
 * Dynamic RB2B visitor-identification loader.
 *
 * Nothing in this module executes at import time — `loadRB2B()` must be
 * called explicitly (only done by ConsentContext once the visitor grants
 * visitor-identification consent). This keeps RB2B from making any network
 * request or setting `window.reb2b` before consent is recorded.
 */

const RB2B_KEY = process.env.REACT_APP_RB2B_KEY || 'GNLKQH7L7W6Q';

let scriptEl = null;
let loaded = false;

/** Whether the RB2B tag is currently injected. */
export const isRB2BLoaded = () => loaded;

/**
 * Injects the RB2B tag. Idempotent — safe to call repeatedly without
 * duplicating the script tag or global.
 */
export function loadRB2B() {
  if (loaded || typeof window === 'undefined' || !RB2B_KEY) return;
  if (window.reb2b?.loaded) {
    loaded = true;
    return;
  }

  window.reb2b = { loaded: true };

  scriptEl = document.createElement('script');
  scriptEl.async = true;
  scriptEl.src = `https://ddwl4m2hdecbv.cloudfront.net/b/${RB2B_KEY}/${RB2B_KEY}.js.gz`;
  scriptEl.setAttribute('data-consent-injected', 'rb2b');
  document.head.appendChild(scriptEl);

  loaded = true;
}

/**
 * Withdraws RB2B as far as is feasible client-side: removes the injected
 * `<script>` tag and the `window.reb2b` global so the tag cannot continue
 * identifying the visitor after consent is revoked.
 */
export function unloadRB2B() {
  if (typeof window === 'undefined') return;

  if (scriptEl?.parentNode) {
    scriptEl.parentNode.removeChild(scriptEl);
  }
  scriptEl = null;
  loaded = false;

  try {
    delete window.reb2b;
  } catch {
    window.reb2b = undefined;
  }
}
